<template>
    <div class="home">
        <b-container fluid>
            <b-row>
              <b-col>
                <h1>Information Change Requests</h1>
              </b-col>
            </b-row>

            <div class="card">
                <div class="card-header">Review</div>
                <div class="card-body">
                    <b-row>
                        <b-col>
                            <b-form-checkbox v-model="assignedOnly" name="assigned-input" switch @change="loadChanges($event)">
                                Show My Assigned Change Requests Only
                            </b-form-checkbox>
                        </b-col>
                    </b-row>
                    <h2>SSN Change Requests</h2>
                    <b-row>
                        <b-col>
                            <b-table hover small show-empty class="sr-caption"
                                     aria-live="polite"
                                     id="ssnTable"
                                     responsive="true"
                                     :fields="ssnChangeFields"
                                     :items="ssnChanges"
                                     :busy="false"
                                     label-sort-asc=""
                                     label-sort-desc=""
                                     sort-by="changeDate"
                                     :sort-desc="true"
                                     :per-page="perPage"
                                     :current-page="currentPageSsn"
                                     :filter="filterSsn"
                                     @filtered="onFilteredSsn"
                                     caption="SSN Change Requests table.  To sort the data in this table by a specific column,
                                go to the appropriate column header cell and use enter to sort the data ascending.
                                Use enter again to sort descending.">
                                <template v-slot:no-data>
                                    No SSN Change Requests Found.
                                </template>
                                <template v-slot:cell(changeDate)="row">
                                    {{formatDate(row.item.changeDate)}}
                                </template>
                                <div slot="table-busy" class="text-center text-danger my-2">
                                    <b-spinner class="align-middle" label="Loading, Please Wait" aria-label="Loading, Please Wait"/>
                                    <strong>Loading...</strong>
                                </div>
                                <template v-slot:cell(actions)="row">
                                    <router-link :to="{name: 'review-change', params: {type: 'ssn', id: row.item.id, uuid: row.item.profileId}}">
                                        <b-button variant="primary">Review</b-button>
                                    </router-link>
                                </template>
                                <template slot="empty" slot-scope="scope">
                                    No SSN Change Requests Found.
                                </template>
                            </b-table>
                            <div class="overflow-auto">
                                <b-pagination
                                        v-if="this.ssnChanges.length > perPage"
                                        v-model="currentPageSsn"
                                        :total-rows="totalRowsSsn"
                                        :per-page="perPage"
                                        align="fill"
                                        aria-controls="ssnTable"
                                        size="sm"/>
                            </div>

                        </b-col>
                    </b-row>
                    <h2>Name Change Requests</h2>
                    <b-row>
                        <b-col>
                            <b-table hover small show-empty class="sr-caption"
                                     id="nameTable"
                                     aria-live="polite"
                                     responsive="true"
                                     :fields="changeFields"
                                     :items="nameChanges"
                                     :busy="false"
                                     sort-by="changeDate"
                                     :sort-desc="true"
                                     label-sort-asc=""
                                     label-sort-desc=""
                                     :per-page="perPage"
                                     :current-page="currentPageName"
                                     :filter="filterName"
                                     @filtered="onFilteredName"
                                     caption="Name Change Requests table.  To sort the data in this table by a specific column,
                                go to the appropriate column header cell and use enter to sort the data ascending.
                                Use enter again to sort descending.">
                                <template v-slot:no-data>
                                    No Name Change Requests Found.
                                </template>
                                <template v-slot:cell(changeDate)="row">
                                    {{formatDate(row.item.changeDate)}}
                                </template>
                                <div slot="table-busy" class="text-center text-danger my-2">
                                    <b-spinner class="align-middle" label="Loading, Please Wait" aria-label="Loading, Please Wait"/>
                                    <strong>Loading...</strong>
                                </div>
                                <template v-slot:cell(actions)="row">
                                    <router-link :to="{name: 'review-change', params: {type: 'name', id: row.item.id, uuid: row.item.profileId}}">
                                        <b-button variant="primary">Review</b-button>
                                    </router-link>
                                </template>
                                <template slot="empty" slot-scope="scope">
                                    No Name Change Requests Found.
                                </template>
                            </b-table>
                            <div class="overflow-auto">
                                <b-pagination
                                        v-if="this.nameChanges.length > perPage"
                                        v-model="currentPageName"
                                        :total-rows="totalRowsName"
                                        :per-page="perPage"
                                        align="fill"
                                        aria-controls="nameTable"
                                        size="sm"/>
                            </div>

                        </b-col>
                    </b-row>
                    <h2>DOB Change Requests</h2>

                        <b-row>
                          <b-col>
                            <b-table hover small show-empty class="sr-caption"
                                     id="unclaimedTable"
                                     aria-live="polite"
                                     responsive="true"
                                     :fields="changeFields"
                                     :items="dobChanges"
                                     :busy="false"
                                     sort-by="changeDate"
                                     :sort-desc="true"
                                     label-sort-asc=""
                                     label-sort-desc=""
                                     :per-page="perPage"
                                     :current-page="currentPageDob"
                                     :filter="filterDob"
                                     @filtered="onFilteredDob"
                                     caption="Date of Birth Change Requests table.  To sort the data in this table by a specific column,
                                go to the appropriate column header cell and use enter to sort the data ascending.
                                Use enter again to sort descending.">
                              <template slot="empty" slot-scope="scope">
                                No Date of Birth Change Requests Found.
                              </template>
                              <template v-slot:cell(changeDate)="row">
                                {{formatDate(row.item.changeDate)}}
                              </template>
                              <div slot="table-busy" class="text-center text-danger my-2">
                                <b-spinner class="align-middle" label="Loading, Please Wait" aria-label="Loading, Please Wait"/>
                                <strong>Loading...</strong>
                              </div>
                              <template v-slot:cell(actions)="row">
                                <router-link :to="{name: 'review-change', params: {type: 'dob', id: row.item.id, uuid: row.item.profileId}}">
                                  <b-button variant="primary">Review</b-button>
                                </router-link>
                              </template>
                            </b-table>
                      </b-col>
                    </b-row>

                    <h2>Unclaimed Certificate Change Requests</h2>
                    <b-row>
                        <b-col>
                            <b-table hover small show-empty class="sr-caption"
                                     id="unclaimedTable"
                                     aria-live="polite"
                                     responsive="true"
                                     :fields="unclaimedChangeFields"
                                     :items="unclaimedChanges"
                                     :busy="false"
                                     sort-by="changeDate"
                                     :sort-desc="true"
                                     label-sort-asc=""
                                     label-sort-desc=""
                                     :per-page="perPage"
                                     :current-page="currentPageUnclaimed"
                                     :filter="filterUnclaimed"
                                     @filtered="onFilteredUnclaimed"
                                     caption="Unclaimed Certificate Requests table.  To sort the data in this table by a specific column,
                                go to the appropriate column header cell and use enter to sort the data ascending.
                                Use enter again to sort descending.">
                                <template v-slot:no-data>
                                    No Unclaimed Certificate Change Requests Found.
                                </template>
                                <template v-slot:cell(changeDate)="row">
                                    {{formatDate(row.item.changeDate)}}
                                </template>
                                <div slot="table-busy" class="text-center text-danger my-2">
                                    <b-spinner class="align-middle" label="Loading, Please Wait" aria-label="Loading, Please Wait"/>
                                    <strong>Loading...</strong>
                                </div>
                                <template v-slot:cell(actions)="row">
                                    <router-link :to="{name: 'review-unclaimed-change', params: {id: row.item.id}}">
                                        <b-button variant="primary">Review</b-button>
                                    </router-link>
                                </template>
                                <template slot="empty" slot-scope="scope">
                                    No Unclaimed Certificate Requests Found.
                                </template>
                            </b-table>
                            <div class="overflow-auto">
                                <b-pagination
                                        v-if="this.unclaimedChanges.length > perPage"
                                        v-model="currentPageUnclaimed"
                                        :total-rows="totalRowsUnclaimed"
                                        :per-page="perPage"
                                        align="fill"
                                        aria-controls="unclaimedTable"
                                        size="sm"/>
                            </div>
                        </b-col>
                    </b-row>
              </div>
            </div>

        </b-container>
    </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment';

export default {
    data: () => ({
        ssnChanges: [],
        nameChanges: [],
        dobChanges: [],
        unclaimedChanges: [],
        changeFields: [
          {key: 'lastName', sortable: true, label: 'Last Name'},
          {key: 'firstName', sortable: true, label: 'First Name'},
          {key: 'changeDate', sortable: true, label: 'Change Date'},
          {key: 'profileSsn', sortable: true, label: 'SSN'},
          {key: 'status', sortable: true, label: 'Status'},
          {key: 'assignedName', label: 'Credentialer Assigned', sortable:true},
          {key: 'actions', label: 'Actions'}
        ],
        unclaimedChangeFields: [
          {key: 'lastName', sortable: true, label: 'Last Name'},
          {key: 'firstName', sortable: true, label: 'First Name'},
          {key: 'changeDate', sortable: true, label: 'Change Date'},
          {key: 'status', sortable: true, label: 'Status'},
          {key: 'assignedName', label: 'Credentialer Assigned', sortable:true},
          {key: 'actions', label: 'Actions'}
        ],
        ssnChangeFields: [
          {key: 'lastName', sortable: true, label: 'Last Name'},
          {key: 'firstName', sortable: true, label: 'First Name'},
          {key: 'changeDate', sortable: true, label: 'Change Date'},
          {key: 'status', sortable: true, label: 'Status'},
          {key: 'assignedName', label: 'Credentialer Assigned', sortable:true},
          {key: 'actions', label: 'Actions'}
        ],
        assignedOnly: false,
        perPage: 10,
        filterSsn: null,
        currentPageSsn: 1,
        totalRowsSsn: 0,
        filterName: null,
        currentPageName: 1,
        totalRowsName: 0,
        filterDob: null,
        currentPageDob: 1,
        totalRowsDob: 0,
        filterUnclaimed: null,
        currentPageUnclaimed: 1,
        totalRowsUnclaimed: 0,
    }),

    mounted() {
        this.loadChanges()
    },

    methods: {
        loadChanges(assignedOnly) {
            if (assignedOnly === undefined) {
                assignedOnly = false
            }
            this.loadSsnChanges(assignedOnly)
            this.loadNameChanges(assignedOnly)
            this.loadDobChanges(assignedOnly)
            this.loadUnclaimedChanges(assignedOnly)
        },
        loadSsnChanges(assignedOnly) {
            axios.get(`${process.env.VUE_APP_API_BASE_URL}/change/ssn/requests/${assignedOnly}`)
                .then(response => {
                    this.ssnChanges = response.data
                    this.totalRowsSsn = response.data.length
                })
        },
        loadNameChanges(assignedOnly) {
            axios.get(`${process.env.VUE_APP_API_BASE_URL}/change/name/requests/${assignedOnly}`)
                .then(response => {
                    this.nameChanges = response.data
                    this.totalRowsName = response.data.length
                })
        },
       loadDobChanges(assignedOnly){
          axios.get(`${process.env.VUE_APP_API_BASE_URL}/change/dob/requests/${assignedOnly}`)
              .then(response => {
                this.dobChanges = response.data
                this.totalRowsDob = response.data.length
              })
       },
        loadUnclaimedChanges(assignedOnly) {
            axios.get(`${process.env.VUE_APP_API_BASE_URL}/change/unclaimed/requests/${assignedOnly}`)
                .then(response => {
                    this.unclaimedChanges = response.data
                    this.totalRowsUnclaimed = response.data.length
                })
        },
        formatDate(unformattedDate){
            let formattedDate = moment(unformattedDate);
            if(!formattedDate.isValid()) return '';
            return formattedDate.format("MM/DD/YYYY")
        },
        onFilteredSsn(filteredItems) {
            this.setTotalRows(filteredItems.length)
            this.currentPageSsn = 1
        },
        onFilteredName(filteredItems) {
            this.setTotalRows(filteredItems.length)
            this.currentPageName = 1
        },
        onFilteredUnclaimed(filteredItems) {
            this.setTotalRows(filteredItems.length)
            this.currentPageUnclaimed = 1
        },
        onFilteredDob(filteredItems) {
          this.setTotalRows(filteredItems.length)
          this.currentPageDob = 1
        }
    },
    created() {
        document.title = "Information Change Review - NAR"
    },
}
</script>

<style>
</style>